module.exports = __webpack_public_path__ + "static/media/UserSettings.78d61063.svg";